var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"handimg-back"},on:{"click":_vm.handback}},[_c('img',{attrs:{"src":_vm.record,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }